import { IData, TypesData } from "@context/types/data";
import { GlobalAction } from "@context/types";

export const dataReducer = (state: IData, action: GlobalAction) => {
  switch (action.type) {
    case TypesData.RefreshData:
      return {
        ...action.payload,
      };
    case TypesData.ResetData:
      return {
        name: null,
        lastname: null,
        docType: null,
        document: null,
        minorityId: null,
        birthday: null,
        epsId: null,
        areas: [],
      };

    default:
      return state;
  }
};
